/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Line_UpInputs */



/**
* | output |
* | --- |
* | "Move Line Up" |
*
* @param {Shortcut_Keys_Name_Move_Line_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_line_up = /** @type {((inputs?: Shortcut_Keys_Name_Move_Line_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Line_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer une ligne vers le haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufstellung nach oben verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la fila")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить состав")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover la alineación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移动阵容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラインを上に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइन अप को आगे बढ़ाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova a fila para cima")
	return /** @type {LocalizedString} */ ("Move Line Up")
});